<script>
import VueSlickCarousel from 'vue-slick-carousel';
import ChevronLeftIcon from '~/static/images/chevron-left.svg';
import ChevronRightIcon from '~/static/images/chevron-right.svg';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
    components: {
        VueSlickCarousel,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    props: {
        component: {
            type: Object,
            default: () => {},
        },
        arrows: {
            type: Boolean,
            default: false,
        },
        dots: {
            type: Boolean,
            default: false,
        },
        slidesCount: {
            type: Number,
            default: 1,
        },
        slidesToShow: {
            type: Number,
            default: 1,
        },
        slidesToScroll: {
            type: Number,
            default: 1,
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        autoplaySpeed: {
            type: Number,
            default: 3000,
        },
        lazyLoad: {
            type: String,
            default: 'ondemand',
        },
        activeSlide: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            carouselActiveSlide: 0,
        };
    },
    watch: {
        activeSlide(index) {
            this.goTo(index);
        },
    },
    mounted() {
        this.goTo(this.activeSlide);
        this.carouselActiveSlide = this.activeSlide;
    },
    methods: {
        goToPrev() {
            this.$refs.carousel.prev();
        },
        goToNext() {
            this.$refs.carousel.next();
        },
        goTo(slide) {
            this.$refs.carousel.goTo(slide);
            this.setActiveSlide(slide);
        },
        setActiveSlide(index) {
            this.carouselActiveSlide = index;
        },
    },
};
</script>

<template>
    <div class="relative">
        <VueSlickCarousel
            ref="carousel"
            :slides-to-show="slidesToShow"
            :slides-to-scroll="slidesToScroll"
            class="slick-multi"
            :autoplay="autoplay"
            :autoplay-speed="autoplaySpeed"
            :lazy-load="lazyLoad"
            :arrows="false"
            :dots="false"
            @afterChange="setActiveSlide($event)"
        >
            <slot />
        </VueSlickCarousel>
        <div
            v-if="arrows"
            class="slide-navigation-button slide-navigation-button--left"
            @click="goToPrev"
        >
            <ChevronLeftIcon class="slide-navigation-button__icon" />
        </div>
        <div
            v-if="arrows"
            class="slide-navigation-button slide-navigation-button--right"
            @click="goToNext"
        >
            <ChevronRightIcon class="slide-navigation-button__icon" />
        </div>
        <div
            v-if="dots"
            class="absolute bottom-0 left-0 right-0 flex justify-center items-center gap-4 pb-4 flex-wrap px-4"
        >
            <button
                v-for="(slide, index) in slidesCount"
                :key="index"
                class="w-4 h-4 rounded-full opacity-75"
                :class="{
                    'bg-primary': index === carouselActiveSlide,
                    'bg-2025-light-beige': index !== carouselActiveSlide,
                }"
                @click="goTo(index)"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.slide-navigation-button {
    @apply absolute text-2025-light-beige cursor-pointer transition-fast transition-property-color flex items-center;
    @apply top-0 bottom-0;
    &--left {
        @apply left-4;
    }
    &--right {
        @apply right-4;
    }
    &__icon {
        @apply w-8 md:w-12 h-8 md:h-12;
    }
    &:hover {
        @apply text-2025-dark-pink;
    }
}
</style>
